import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import {IMenu} from '../modules/menu-management/menu/_modal'
import {GET_MENU_LIST_URL} from '../modules/menu-management/menu/MenuList'
import axios from 'axios'

const useMenuList = () => {
  const [optionsMenu, setOptionsMenu] = useState<ISelectOption[]>([])
  const [options, setOptions] = useState<IMenu[]>([])

  useEffect(() => {
    const getLinkList = async () => {
      try {
        const response = await axios.get<{data: IMenu[]}>(GET_MENU_LIST_URL)
        const data = await response.data
        const result = await data.data
        // console.log(result)
        const formatted = result.map((link) => ({
          id: link.id_menu,
          value: link.menu_name,
          label: link.menu_name,
        }))
        setOptions(result || [])
        setOptionsMenu(formatted || [])
      } catch (error) {
        console.log(error)
      }
    }

    getLinkList()
  }, [])

  return {
    optionsMenu,
    options,
  }
}

export default useMenuList
